module.exports = "/images/box-loja.png?d23f05a95b6f6e46344312136d43a61a";